import React from "react";

import { FormLabel, HStack, Icon, Text } from "@chakra-ui/react";

export default function ModalFieldLabel({ icon, children }) {
	return (
		<FormLabel fontSize="sm" color="gray.600" mb={1.5}>
			{icon ? (
				<HStack spacing={2}>
					<Icon as={icon} boxSize={4} />
					<Text>{children}</Text>
				</HStack>
			) : (
				<Text>{children}</Text>
			)}
		</FormLabel>
	);
}
